var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.9H10.4V3V6V6.1H10.5H13.5H13.6V6V3V2.9H13.5H10.5ZM3 2.9H2.9V3V6V6.1H3H6H6.1V6V3V2.9H6H3ZM18 2.9H17.9V3V6V6.1H18H21H21.1V6V3V2.9H21H18ZM10.5 10.4H10.4V10.5V13.5V13.6H10.5H13.5H13.6V13.5V10.5V10.4H13.5H10.5ZM3 10.4H2.9V10.5V13.5V13.6H3H6H6.1V13.5V10.5V10.4H6H3ZM18 10.4H17.9V10.5V13.5V13.6H18H21H21.1V13.5V10.5V10.4H21H18ZM10.5 17.9H10.4V18V21V21.1H10.5H13.5H13.6V21V18V17.9H13.5H10.5ZM3 17.9H2.9V18V21V21.1H3H6H6.1V21V18V17.9H6H3ZM18 17.9H17.9V18V21V21.1H18H21H21.1V21V18V17.9H21H18Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.c660f648ec7adb394621cefa47d8fa2b.svg";
export { ForwardRef as ReactComponent };